import { Relative } from '../api/app-types/relative.app';

export const createRelative = (overrides: Partial<Relative> = {}): Relative => ({
	id: 'relative-1',
	objectId: 'object-1',
	displayName: 'Relative Display',
	firstName: 'Jane',
	lastName: 'Doe',
	isActive: true,
	categoryPersonCategory: {
		id: 1,
		name: 'Family',
		isPersonal: true,
	},
	personType: {
		id: 1,
		name: 'Family',
		isInitiator: false,
	},
	isSupervisor: false,
	hasBeenClarified: false,
	...overrides,
});
